<ng-template #contentHeaderTemplate></ng-template>

<div class="d-flex flex-column h-100" *ngIf="dateValid">

  <app-event-calendar-toolbar
    [currentStart]="currentStart"
    [view]="view"
    (weekJump)="onWeekJump($event)"
    (dateChange)="datePickerChanged($event)"
  ></app-event-calendar-toolbar>

  <div class="d-flex " *ngIf="showFilters">
    <div class="card mb-3">
      <div class="card-body">
        <app-table-filter-loader
          *ngIf="tableDisplayConfig"
          [showFavorites]="true"
          [tableDisplayConfig]="tableDisplayConfig"
          [showToggleButtons]="false"
          [showFilters]="showFilters"
          (tableDisplayConfigChange)="filterLoaded($event)"
          (resetFilter)="resetFilter()"
        ></app-table-filter-loader>

        <app-table-filter
          *ngIf="tableDisplayConfig"
          [tableDisplayConfig]="tableDisplayConfig"
          [globalFilter]="{'start_datetime': '1', 'dashboard_category':'1', 'end_datetime': '1'}"
          (tableDisplayConfigChange)="filtersChanged($event)"
          [compactView]="true"
          [smallInput]="false"
          [inlineInput]="false"
        ></app-table-filter>
      </div>
    </div>

  </div>

  <div class="flex-grow-1 overflow-hidden">

    <full-calendar #calendarComponent appStickyOccurrences class="{{ view }}" [options]="calendarOptions">
      <ng-template #eventContent let-arg>
        @let entry = getCalendarByGroupEntry(arg);
        @let styling = entry.styling;

        @if (entry.type === EventmanagementCalendarEntryTypeEnum.OCCURRENCE) {
          @let occurrence = entry.occurrence;
          <div
            class="occurrence-entry"
            [class.occurrence-closure]="occurrence?.category === OccurrenceCategoryEnum.CLOSURE"
            (click)="entryClicked(entry)"
          >
            <strong>{{ occurrence?.internal_title }}</strong>, {{ entry.start_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'dd.MM.yyyy HH:mm' }} - {{ entry.end_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'dd.MM.yyyy HH:mm' }}
          </div>
        } @else {
          <div
            style="padding: 5px; height: 95px; text-wrap: nowrap; overflow: hidden; cursor: pointer"
            [style.color]="styling.font_color"
            [style.border-top]="styling.top_border.width + ' solid ' + styling.top_border.color"
            [style.border-right]="styling.right_border.width + ' solid ' + styling.right_border.color"
            [style.border-bottom]="styling.bottom_border.width + ' solid ' + styling.bottom_border.color"
            [style.border-left]="styling.left_border.width + ' solid ' + styling.left_border.color"
            [style.background]="'repeating-linear-gradient(45deg, ' + styling.primary_background_color + ', ' + styling.primary_background_color + ' 10px, ' + styling.secondary_background_color + ' 10px, ' + styling.secondary_background_color + ' 20px)'"
            (click)="entryClicked(entry)"
          >

            @let event = entry.event;

            @switch (entry.type) {
              @case (EventmanagementCalendarEntryTypeEnum.EVENT_EVENT_RESOURCE) {
                @let event_resource = entry.event_resource;
                @let phase = event_resource?.event_phase;

                @if (phase === EventPhaseEnum.EVENT_PHASE) {
                  <strong>{{ event?.title ?? '' }}, {{ event?.ext_event_id ?? '' }}</strong><br>

                  @if (event?.project_manager_one) {
                    <span>PM ({{ event?.project_manager_one?.last_name }}
                      , {{ (event?.project_manager_one?.first_name ?? ' ')[0] }}), </span>
                  }

                  @if (event?.operations_manager_one) {
                    <span>OM ({{ event?.operations_manager_one?.last_name }}
                      , {{ (event?.operations_manager_one?.first_name ?? ' ')[0] }})</span>
                  }

                  @if (event?.project_manager_one || event?.operations_manager_one) {
                    <br>
                  }

                  @if (view === 'month') {
                    <span>{{ entry?.start_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'dd.MM.yyyy HH:mm' }} - {{ entry?.end_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'dd.MM.yyyy HH:mm' }}</span><br>
                  } @else {
                    <span>{{ event_resource?.event_phase_start_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'dd.MM.yyyy HH:mm' }} - {{ event_resource?.event_phase_end_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'dd.MM.yyyy HH:mm' }}</span><br>
                  }


                  <span>{{ ('enums.eventResourceStateEnum.' + event_resource?.state) | translate }}</span>

                } @else {
                  <strong>{{ ('enums.eventPhaseEnum.' + phase) | translate }}</strong>
                }
              }
              @case (EventmanagementCalendarEntryTypeEnum.BLOCKED_RESOURCE) {
                @let blocked_resource = entry.blocked_resource;

                <strong>{{ blocked_resource?.blocked_resource_definition?.title }}</strong><br>
                <span>{{ 'enums.blockedResourceCategoryEnum.' + blocked_resource?.blocked_resource_definition?.category | translate }}</span>

                @if (blocked_resource?.blocked_resource_definition?.event_id) {
                  <br>
                  <span>{{ blocked_resource?.blocked_resource_definition?.event?.title }}</span><br>
                  <span>{{ blocked_resource?.blocked_resource_definition?.event?.ext_event_id }}</span>
                }
              }
            }

          </div>
        }
      </ng-template>

      <ng-template #resourceLabelContent let-arg>
        <span [class.fw-bold]="arg.resource.extendedProps.isRoom" class="text-wrap">{{ arg.resource.title }}</span>
      </ng-template>

      <ng-template #resourceLaneContent let-arg>
        @if (arg.resource.extendedProps.roomIsNotPublished) {
          <div class="not-published-room-row"></div>
        }
      </ng-template>
    </full-calendar>

  </div>

</div>
